import type { Roadnet, Snapshot, StartParams, StartResponse } from './types'

export type ReportItem = {
  run_id: string
  created_at: string
  status: string
  sim_time: number
  map: string
  algorithm: string
  vehicle_count: number
  passenger_rate: number
  total: number
  served: number
  cancelled: number
  avg_pickup_wait_s: number
  avg_trip_s: number
}

export class ApiError extends Error {
  status: number

  constructor(status: number, message: string) {
    super(message)
    this.status = status
  }
}

async function json<T>(url: string, init?: RequestInit): Promise<T> {
  const response = await fetch(url, init)
  if (!response.ok) {
    const body = await response.json().catch(() => ({}))
    throw new ApiError(response.status, body.detail || `请求失败：${response.status}`)
  }
  return response.json() as Promise<T>
}

export function startLive(params: StartParams): Promise<StartResponse> {
  return json<StartResponse>('/api/live/start', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(params),
  })
}

export function getSnapshot(advanceS: number): Promise<Snapshot> {
  return json<Snapshot>(`/api/live/snapshot?advance_s=${advanceS}`)
}

export function getRoadnet(): Promise<Roadnet> {
  return json<Roadnet>('/api/live/roadnet')
}

export function getReports(): Promise<ReportItem[]> {
  return json<{ reports: ReportItem[] }>('/api/reports').then((body) => body.reports)
}

export function reportUrl(runId: string): string {
  return `/api/reports/${runId}/report.html`
}
